import { g as __rest, b as __assign } from '../../../../_tslib-7a01aab4.js';
import React from 'react';

var TabItem = function (_a) {
    var text = _a.text, _b = _a.className, className = _b === void 0 ? '' : _b, rest = __rest(_a, ["text", "className"]);
    return (React.createElement("div", __assign({ className: "view-select-tab ".concat(className), title: text }, rest),
        React.createElement("div", { className: 'view-select-tab-inner' },
            React.createElement("p", { className: 'view-select-tab-txt' }, text))));
};

export { TabItem };
